import React from 'react';
import { useScrollProgress } from '../../hooks/useReveal';
import './EvolveLoop.scss';

const STEPS = [
    { name: 'Idea', note: 'A problem worth solving' },
    { name: 'Experiment', note: 'Prove it can work' },
    { name: 'Build', note: 'Engineer the product' },
    { name: 'Ship', note: 'Put it in the world' },
    { name: 'Learn', note: 'Listen to real usage' },
    { name: 'Evolve', note: 'Then do it again' },
];

const EvolveLoop = () => {
    const [ref, progress] = useScrollProgress();

    // Stretch the middle of the scroll range across the six steps.
    const eased = Math.min(1, Math.max(0, (progress - 0.15) / 0.6));
    const activeIndex = Math.min(STEPS.length - 1, Math.floor(eased * STEPS.length));

    return (
        <section className="evolve-loop" ref={ref}>
            <div className="el-inner">
                <div className="el-head">
                    <span className="el-eyebrow">The Evolve Loop</span>
                    <h2 className="el-title">
                        Software is never
                        <br />
                        <span className="el-title-accent">really finished.</span>
                    </h2>
                </div>

                <ol
                    className="el-steps"
                    style={{ '--fill': `${eased * 100}%` }}
                >
                    <span className="el-rail" aria-hidden="true">
                        <span className="el-rail-fill" />
                    </span>

                    {STEPS.map((step, i) => (
                        <li
                            key={step.name}
                            className={`el-step ${i <= activeIndex ? 'is-on' : ''} ${
                                i === activeIndex ? 'is-current' : ''
                            }`}
                        >
                            <span className="el-step-node" aria-hidden="true" />
                            <span className="el-step-num">
                                {String(i + 1).padStart(2, '0')}
                            </span>
                            <span className="el-step-name">{step.name}</span>
                            <span className="el-step-note">{step.note}</span>
                        </li>
                    ))}

                    <li className="el-step el-step-loop" aria-hidden="true">
                        <span className="el-loop-mark">↺</span>
                        <span className="el-step-note">Repeat</span>
                    </li>
                </ol>
            </div>
        </section>
    );
};

export default EvolveLoop;
